// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatastkbptv2 } from "../../../icons/full/build/icon-statastkbptv2.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatastkbptvTwoIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatastkbptv2.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatastkbptvTwoIcon.displayName = 'StatastkbptvTwoIcon';
}

export default StatastkbptvTwoIcon;